import React, { useEffect, useLayoutEffect, useRef, useState } from "react";

export const ReplaceQuestionComponent = React.forwardRef((props, ref) => {
  const { name, defaultValue, onChange } = props;

  const [selectedOption, setSelectedOption] = useState(
    defaultValue || props.default || ""
  );
  const generateUniqueId = () => {
    const baseId = "fid_preview_radiobuttons_option_";
    const uniqueId = new Date().getTime().toString(36);
    return `${baseId}${uniqueId}`;
  };

  const uniqueId = generateUniqueId();

  const yesId = `passOption_${Math.random().toString(36).substr(2, 9)}`;
  const noId = `failOption_${Math.random().toString(36).substr(2, 9)}`;

  const yesRef = useRef(null);
  const noRef = useRef(null);

  // useLayoutEffect to ensure refs are available before rendering
  useLayoutEffect(() => {
    // if (passRef.current) {
    //   passRef.current.id = `passOption_${Math.random()
    //     .toString(36)
    //     .substr(2, 9)}`;
    // }
    // if (failRef.current) {
    //   failRef.current.id = `failOption_${Math.random()
    //     .toString(36)
    //     .substr(2, 9)}`;
    // }

    if (ref && (props.default === "yes" || props.default === "no")) {
      ref.current = yesRef.current; // Assigning the DOM element to the forwarded ref
    }
  }, []);

  const handleOptionChange = (event) => {
    const value = event.target.value;
    ref.current = event.target;
    setSelectedOption(value);

    if (onChange) {
      onChange(name, value);
    }
  };

  const formatLabel = (label) => {
    return label;
  };

  return (
    <div className="form-group replace">
      <label className="form-label">
        <span>
          <span>Did you replace the seal?</span>
        </span>
      </label>

      <div className="custom-control custom-radio-passfail option-inline">
        <input
          className="custom-control-input"
          name={name}
          type="radio"
          value="yes"
          defaultValue={defaultValue}
          checked={selectedOption === "yes"}
          onChange={handleOptionChange}
          id={yesId}
          ref={yesRef}
        />
        <label className="custom-control-label-passfail" htmlFor={yesId}>
          Yes
        </label>
      </div>
      <div className="custom-control custom-radio-passfail option-inline">
        <input
          className="custom-control-input"
          name={name}
          type="radio"
          value="no"
          defaultValue={defaultValue}
          checked={selectedOption === "no"}
          onChange={handleOptionChange}
          id={noId}
          ref={noRef}
        />
        <label className="custom-control-label-passfail" htmlFor={noId}>
          No
        </label>
      </div>
    </div>
  );
});